function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as m } from "./index.es33.js";
import { useMemo as p, useState as u, useEffect as x } from "react";
import { nanoid as E } from "nanoid";
import { clsx as g } from "./index.es105.js";
import { Typography as w } from "./index.es35.js";
import "./index.es36.js";
import { Tooltip as T } from "./index.es13.js";
import { DELAY_BEFORE_SHOW_TOOLTIP as y } from "./index.es15.js";
import a from "./index.es179.js";
var H = function H(t) {
  var i = t.maxWidth,
    s = t.lineCount,
    c = t.title,
    o = t.isVisibleDisabled,
    _t$showTooltipDelay = t.showTooltipDelay,
    l = _t$showTooltipDelay === void 0 ? y : _t$showTooltipDelay,
    r = p(E, []),
    _u = u(!1),
    _u2 = _slicedToArray(_u, 2),
    d = _u2[0],
    h = _u2[1];
  return x(function () {
    if (!o) {
      var n = function n() {
          var e = document.getElementById(r);
          e && h(e.clientWidth < e.scrollWidth || e.clientHeight < e.scrollHeight);
        },
        f = setTimeout(n, l * 2);
      return window.addEventListener("resize", n), function () {
        clearTimeout(f), window.removeEventListener("resize", n);
      };
    }
  }, [i, c, o, l]), m.jsx(T, _objectSpread(_objectSpread({}, t), {}, {
    isVisibleDisabled: !!(!d || o),
    children: m.jsx(w.Body2, {
      className: g(a.title, _defineProperty({}, a.multiline, !!s)),
      as: "span",
      style: {
        maxWidth: i ? "".concat(i, "px") : "100%",
        WebkitLineClamp: s
      },
      id: r,
      children: t.children || t.title
    })
  }));
};
export { H as TooltipShorten };